import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Hunter from "../components/Settings/APISettings/Hunter";
import Tomba from "../components/Settings/APISettings/Tomba";
import Abstract from "../components/Settings/APISettings/Abstract";
import Toaster from "../components/Toaster";
import { getApiSettings } from "../redux/actions/apiSettings";

const ApiSettings = () => {
  const [tab, setTab] = useState(1);

  const dispatch = useDispatch();

  const allemailApis = useSelector((state) => state.emailApi);
  const { loading, emailApis } = allemailApis;

  useEffect(() => {
    dispatch(getApiSettings());
  }, [dispatch]);

  return (
    <>
      <div className="container apiSettingsPage">
        <div className="headings apiHeadingWraper">
          <h3>API Key Settings</h3>
        </div>
        {/* <ul className='tabs'> */}
        {/* <li
						className={tab === 1 ? 'tab-link current' : 'tab-link'}
						data-tab='tab-1'
						onClick={(e) => setTab((val) => 1)}
					>
						Hunter
					</li> */}
        {/* <li
						className={tab === 3 ? 'tab-link current' : 'tab-link'}
						data-tab='tab-3'
						onClick={(e) => setTab((val) => 3)}
					>
						Abstract
					</li>
					<li
						className={tab === 1 ? 'tab-link current' : 'tab-link'}
						data-tab='tab-1'
						onClick={(e) => setTab((val) => 1)}
					>
						Hunter
					</li>
					<li
						className={tab === 2 ? 'tab-link current' : 'tab-link'}
						data-tab='tab-2'
						onClick={(e) => setTab((val) => 2)}
					>
						Tomba
					</li> */}
        {/* <li
						className={tab === 3 ? 'tab-link current' : 'tab-link'}
						data-tab='tab-3'
						onClick={(e) => setTab((val) => 3)}
					>
						Abstract
					</li> */}

        {/* </ul> */}
        <div className="contentWraper apiWrapers">
          <div className="radioContentWrapers">
            <div className="inlineform">
              <label className="radio">
                <input
                  type="radio"
                  name="Hunter"
                  value="1"
                  onChange={(e) => setTab((val) => 1)}
                  checked={tab === 1 ? true : false}
                />
                <span className="text">Hunter</span>
                <span className="round"></span>{" "}
              </label>

              <label className="radio">
                <input
                  type="radio"
                  name="Abstract"
                  value="2"
                  onChange={(e) => setTab((val) => 2)}
                  checked={tab === 2 ? true : false}
                />
                <span className="text">Tomba</span>
                <span className="round"></span>{" "}
              </label>

              <label className="radio">
                <input
                  type="radio"
                  name="Tomba"
                  value="3"
                  onChange={(e) => setTab((val) => 3)}
                  checked={tab === 3 ? true : false}
                />
                <span className="text">Abstract</span>
                <span className="round"></span>{" "}
              </label>
            </div>
          </div>
          {tab === 1 && <Hunter loading={loading} emailApis={emailApis} />}
          {tab === 2 && <Tomba loading={loading} emailApis={emailApis} />}
          {tab === 3 && <Abstract loading={loading} emailApis={emailApis} />}
          </div>
        </div>
      <Toaster />
    </>
  );
};

export default ApiSettings;
